import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { TeamDetailsForm } from '../-components/team-details-form';
import { teamDetailsQueryOptions } from '../-utils/team-settings-query';
import {
  SettingsSection,
  SettingsSectionSkeleton,
} from '../../settings/-components/settings-section';
import { SETTINGS_HELP } from '../../settings/-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/organization-settings/team/details',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      teamDetailsQueryOptions(context.activeDashboard.team ?? ''),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: TeamDetailsPage,
  head: () => ({ meta: [{ title: t`Team details` }] }),
});

function TeamDetailsPage() {
  const { activeDashboard } = Route.useRouteContext();
  const { data: details } = useSuspenseQuery(
    teamDetailsQueryOptions(activeDashboard.team ?? ''),
  );

  return (
    <SettingsSection
      title={t`Team details`}
      description={t`The team's name, description and picture.`}
      helpUrl={SETTINGS_HELP.teams}
    >
      {/* Keyed so the form re-seeds after another team becomes active. */}
      <TeamDetailsForm key={details.teamId} details={details} />
    </SettingsSection>
  );
}
